import React, { useEffect, useState } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { Link, Navigate } from "react-router-dom";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faShoppingCart,
  faBoxOpen,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ApiUrl from "./../Environment/ApiUrl";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);



function Dashboard() {
  const [responseDailyRates, setResponseDailyRates] = useState([]);
  const [responseDashboard, setResponseDashboard] = useState({});
  const [responseLoanStatus, setResponseLoanStatus] = useState({});
  const [chitlistdashboard, setchitlistdashboard] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [showReport, setShowReport] = useState(true);
  const [staffreport, setStaffReport] = useState([]);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  // Chart data states
  const [chartPeriod, setChartPeriod] = useState("day"); // 'day', 'month', 'year'
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [isChartLoading, setIsChartLoading] = useState(false);

  useEffect(() => {
    fetchDailyRates();
    fetchDashboard();
    fetchLoanStatus();
    fetchReport();
    fetchchitlistStatus();
    fetchChartData("day"); // Load initial chart data
  }, []);

  const fetchReport = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/staff_report_dashboard.php`);
      setStaffReport(response.data.data || []);
    } catch (error) {
      console.error("Error fetching report:", error.message);
      setError("Failed to fetch report. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // const groupedData = staffreport.reduce((acc, item) => {
  //   if (!acc[item.manager]) {
  //     acc[item.manager] = [];
  //   }
  //   acc[item.manager].push(item);
  //   return acc;
  // }, {});


  // Group data by manager_id
  const groupedData = staffreport.reduce((acc, item) => {
    const managerId = item.manager_id || 'Unknown'; // Fallback if manager_id is missing
    if (!acc[managerId]) {
      acc[managerId] = {
        managerName: item.manager || 'Unknown Manager', // Store manager name for display
        staffList: [],
      };
    }
    acc[managerId].staffList.push({
      staff: item.staff,
      staff_id: item.staff_id,
      total_sales: item.total_sales,
    });
    return acc;
  }, {});

  const fetchDailyRates = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php`);
      console.log("response from daily_rates", response.data);

      // Get current date in both formats used in the API
      const today = new Date();
      const currentDateFormatted1 = today
        .toLocaleDateString("en-GB")
        .split("/")
        .join("-"); // DD-MM-YYYY
      const currentDateFormatted2 = today.toISOString().split("T")[0]; // YYYY-MM-DD

      // Filter data to only include entries from the current date
      const todayData = response.data.data.filter((item) => {
        return (
          item.date === currentDateFormatted1 ||
          item.created_date === currentDateFormatted2
        );
      });

      setResponseDailyRates(todayData || []);
    } catch (error) {
      console.log("error", error.message);
      setError("Failed to fetch rates. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };
  const fetchDashboard = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/dashboard.php`);
      console.log("response from dashboard", response.data);
      setResponseDashboard(response.data.data || {});
    } catch (error) {
      console.log("error", error.message);
      setError("Failed to fetch dashboard data. Please try again later.");
    }
  };

  const fetchLoanStatus = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/loan_dashboard.php`);
      console.log("response from loan_dashboard", response.data.summary);
      setResponseLoanStatus(response.data?.summary || {});
    } catch (error) {
      console.log("error", error.message);
      setError("Failed to fetch loan status data. Please try again later.");
    }
  };

  const fetchchitlistStatus = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/chit_list_dashboard.php`);
      console.log("response from chit_list_dashboard", response.data.summary);
      setchitlistdashboard(response.data?.summary || {});
    } catch (error) {
      console.log("error", error.message);
      setError("Failed to fetch chit status data. Please try again later.");
    }
  };

  // Generate date ranges based on period
  const generateDateRange = (period) => {
    const dates = [];
    const today = new Date();

    switch (period) {
      case "day":
        for (let i = 6; i >= 0; i--) {
          const date = new Date(today);
          date.setDate(today.getDate() - i);
          dates.push(date.toISOString().split("T")[0]);
        }
        break;
      case "month":
        for (let i = 5; i >= 0; i--) {
          const date = new Date(today);
          date.setMonth(today.getMonth() - i);
          dates.push(
            `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
              2,
              "0"
            )}`
          );
        }
        break;
      case "year":
        for (let i = 1; i >= 0; i--) {
          const year = today.getFullYear() - i;
          dates.push(year.toString());
        }
        break;
    }
    return dates;
  };

  // Generate labels for chart
  const generateLabels = (period, dates = []) => {
    const today = new Date();

    switch (period) {
      case "day":
        return dates.map((dateStr) => {
          const date = new Date(dateStr);
          return date.toLocaleDateString("en-US", {
            weekday: "short",
            month: "short",
            day: "numeric",
          });
        });
      case "month":
        const monthLabels = [];
        for (let i = 5; i >= 0; i--) {
          const date = new Date(today);
          date.setMonth(today.getMonth() - i);
          monthLabels.push(
            date.toLocaleDateString("en-US", {
              month: "short",
              year: "numeric",
            })
          );
        }
        return monthLabels;
      case "year":
        const yearLabels = [];
        for (let i = 1; i >= 0; i--) {
          yearLabels.push((today.getFullYear() - i).toString());
        }
        return yearLabels;
    }
  };

  // Process chart data from API response - FIXED VERSION
  const processChartData = (salesData, purchaseData, period) => {
    const dateRange = generateDateRange(period);

    // Create a map for quick lookup - using arrays to accumulate values
    const salesMap = {};
    const purchaseMap = {};

    // Initialize maps with 0 values for all dates in range
    dateRange.forEach((date) => {
      salesMap[date] = 0;
      purchaseMap[date] = 0;
    });

    // Process sales data - SUM values for same periods
    salesData.forEach((item) => {
      let date;
      switch (period) {
        case "day":
          date = item.date;
          break;
        case "month":
          date = item.date.substring(0, 7); // YYYY-MM
          break;
        case "year":
          date = item.date.substring(0, 4); // YYYY
          break;
        default:
          date = item.date;
      }

      // Add to existing value instead of overwriting
      if (salesMap.hasOwnProperty(date)) {
        salesMap[date] += parseFloat(item.total) || 0;
      } else {
        // For dates not in our range, we might still want to include them
        // if they fall within the period we're looking at
        const itemDate = new Date(item.date);
        const isInRange = dateRange.some((rangeDate) => {
          if (period === "day") {
            return rangeDate === item.date;
          } else if (period === "month") {
            return rangeDate === item.date.substring(0, 7);
          } else if (period === "year") {
            return rangeDate === item.date.substring(0, 4);
          }
          return false;
        });

        if (isInRange) {
          salesMap[date] =
            (salesMap[date] || 0) + (parseFloat(item.total) || 0);
        }
      }
    });

    // Process purchase data - SUM values for same periods
    purchaseData.forEach((item) => {
      let date;
      switch (period) {
        case "day":
          date = item.date;
          break;
        case "month":
          date = item.date.substring(0, 7); // YYYY-MM
          break;
        case "year":
          date = item.date.substring(0, 4); // YYYY
          break;
        default:
          date = item.date;
      }

      // Add to existing value instead of overwriting
      if (purchaseMap.hasOwnProperty(date)) {
        purchaseMap[date] += parseFloat(item.current) || 0;
      } else {
        // For dates not in our range, we might still want to include them
        // if they fall within the period we're looking at
        const isInRange = dateRange.some((rangeDate) => {
          if (period === "day") {
            return rangeDate === item.date;
          } else if (period === "month") {
            return rangeDate === item.date.substring(0, 7);
          } else if (period === "year") {
            return rangeDate === item.date.substring(0, 4);
          }
          return false;
        });

        if (isInRange) {
          purchaseMap[date] =
            (purchaseMap[date] || 0) + (parseFloat(item.current) || 0);
        }
      }
    });

    // Map data to date range
    const salesValues = dateRange.map((date) => salesMap[date] || 0);
    const purchaseValues = dateRange.map((date) => purchaseMap[date] || 0);

    // Debug logging
    console.log("Period:", period);
    console.log("Date Range:", dateRange);
    console.log("Sales Map:", salesMap);
    console.log("Purchase Map:", purchaseMap);
    console.log("Sales Values:", salesValues);
    console.log("Purchase Values:", purchaseValues);

    return {
      salesValues,
      purchaseValues,
      dateRange,
    };
  };

  // Fetch chart data based on period using the new API
  const fetchChartData = async (period) => {
    setIsChartLoading(true);
    setError(null);

    try {
      let apiEndpoint = `${ApiUrl}/Api/chart_dashboard.php`;

      // Add period parameter if your API supports it
      // For now, using the default endpoint which returns last 7 days
      if (period === "month") {
        apiEndpoint += "?period=month";
      } else if (period === "year") {
        apiEndpoint += "?period=year";
      }

      const response = await axios.get(apiEndpoint);
      console.log("Chart API Response:", response.data);

      if (
        response.data.status &&
        response.data.sales &&
        response.data.purchases
      ) {
        const { salesValues, purchaseValues, dateRange } = processChartData(
          response.data.sales,
          response.data.purchases,
          period
        );

        const labels = generateLabels(period, dateRange);

        setChartData({
          labels: labels,
          datasets: [
            {
              label: "Sales (₹)",
              data: salesValues,
              backgroundColor: "rgba(0, 123, 255, 0.8)",
              borderColor: "#007bff",
              borderWidth: 1,
              borderRadius: 4,
            },
            {
              label: "Purchases (₹)",
              data: purchaseValues,
              backgroundColor: "rgba(40, 167, 69, 0.8)",
              borderColor: "#28a745",
              borderWidth: 1,
              borderRadius: 4,
            },
          ],
        });
      } else {
        throw new Error("Invalid API response format");
      }
    } catch (error) {
      console.error("Error fetching chart data:", error);
      setError("Failed to fetch chart data. Please try again later.");

      // Fallback to empty chart
      setChartData({
        labels: [],
        datasets: [],
      });
    } finally {
      setIsChartLoading(false);
    }
  };

  // Handle period change
  const handlePeriodChange = (period) => {
    setChartPeriod(period);
    fetchChartData(period);
  };

  // Helper function to safely access nested properties
  const getNestedValue = (obj, path, defaultValue = "N/A") => {
    return path.split(".").reduce((current, key) => {
      return current && current[key] !== undefined
        ? current[key]
        : defaultValue;
    }, obj);
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: "#333",
          font: {
            size: 12,
          },
        },
      },
      title: {
        display: true,
        text: `Sales vs Purchases - ${chartPeriod === "day"
          ? "Last 7 Days"
          : chartPeriod === "month"
            ? "Last 6 Months"
            : "Last 2 Years"
          }`,
        color: "#333",
        font: {
          size: 14,
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#666",
          font: {
            size: 10,
          },
        },
        grid: {
          color: "#e0e0e0",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#666",
          font: {
            size: 10,
          },
          callback: function (value) {
            return "₹" + value.toLocaleString();
          },
        },
        grid: {
          color: "#e0e0e0",
        },
      },
    },
    animation: {
      duration: 1000,
      easing: "easeInOutQuart",
    },
  };

  return (
    <div className="container-fluid mb-5">
      {/* Error Message */}
      {/* {error && <div className="alert alert-danger">{error}</div>} */}

      {/* Loading State */}
      {/* {isLoading && <div className="alert alert-info">Loading...</div>} */}

      {/* Dashboard Cards */}
      {!isLoading && (
        <div className="row mb-2 mt-3">
          <div className="col-lg-3 mb-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body" onClick={() => navigate("/sales")}>

                <div className="d-flex justify-content-between">


                  <div >
                    <h6 className="card-title">Sales</h6>
                    <h6 className="text-success mb-0">
                      ₹{" "}
                      {Math.round(
                        getNestedValue(responseDashboard, "sales.total", "0")
                      ).toLocaleString()}
                      {/* ₹ {Math.round(getNestedValue(responseDashboard, "sales.total", "0"))} */}
                    </h6>
                    <p className="text-muted mb-0">
                      Today: ₹{" "}
                      {getNestedValue(responseDashboard, "sales.today", "0")}
                    </p>
                  </div>
                  <div
                    className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <FontAwesomeIcon
                      icon={faChartLine}
                      className="text-success"
                      size="md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 mb-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body" onClick={() => navigate("/purchases")}>
                <div className="d-flex justify-content-between">
                  <div >
                    <h6 className="card-title">Purchases</h6>
                    <h6 className="text-warning mb-0">
                      ₹{" "}
                      {Math.round(
                        getNestedValue(
                          responseDashboard,
                          "purchases.opening_total",
                          "0"
                        )
                      ).toLocaleString()}
                    </h6>
                    <p className="text-muted mb-0">
                      Today: ₹{" "}
                      {getNestedValue(
                        responseDashboard,
                        "purchases.opening_today",
                        "0"
                      )}

                    </p>
                  </div>
                  <div
                    className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <FontAwesomeIcon
                      icon={faShoppingCart}
                      className="text-warning"
                      size="md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 mb-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body" onClick={() => navigate("/stocks")}>
                <div className="d-flex justify-content-between">
                  <div  >
                    <h6 className="card-title">Stocks</h6>
                    <h6 className="text-warning mb-0">
                      {getNestedValue(responseDashboard, "stock.total", "0")}
                    </h6>
                    <p className="text-muted mb-0">
                      Today:{" "}
                      {getNestedValue(responseDashboard, "stock.today", "0")}
                    </p>
                  </div>
                  <div
                    className="rounded-circle bg-purple bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "rgba(138, 43, 226, 0.1)",
                      width: "60px",
                      height: "60px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faBoxOpen}
                      className="text-purple"
                      size="md"
                      style={{ color: "blueviolet" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 mb-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body" onClick={() => navigate("/customers")}>
                <div className="d-flex justify-content-between">
                  <div  >
                    <h6 className="card-title">Customers</h6>
                    <h6 className="text-danger mb-0">
                      {getNestedValue(
                        responseDashboard,
                        "customers.total",
                        "0"
                      )}
                    </h6>
                    <p className="text-muted mb-0">
                      Today:{" "}
                      {getNestedValue(
                        responseDashboard,
                        "customers.today",
                        "0"
                      )}
                    </p>
                  </div>
                  <div
                    className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <FontAwesomeIcon
                      icon={faUsers}
                      className="text-danger"
                      size="md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Charts and Rate Section */}
      {!isLoading && (
        <div className="row mt-3">
          <div className="col-lg-7">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="card-title mb-0">Analytics Overview</h6>
                  <div className="btn-group" role="group">
                    <button
                      className={`btn btn-sm ${chartPeriod === "day"
                        ? "btn-primary"
                        : "btn-outline-primary"
                        }`}
                      style={{ fontSize: "12px" }}
                      onClick={() => handlePeriodChange("day")}
                      disabled={isChartLoading}
                    >
                      7 Days
                    </button>
                    <button
                      className={`btn btn-sm ${chartPeriod === "month"
                        ? "btn-primary"
                        : "btn-outline-primary"
                        }`}
                      style={{ fontSize: "12px" }}
                      onClick={() => handlePeriodChange("month")}
                      disabled={isChartLoading}
                    >
                      6 Months
                    </button>
                    <button
                      className={`btn btn-sm ${chartPeriod === "year"
                        ? "btn-primary"
                        : "btn-outline-primary"
                        }`}
                      style={{ fontSize: "12px" }}
                      onClick={() => handlePeriodChange("year")}
                      disabled={isChartLoading}
                    >
                      2 Years
                    </button>
                  </div>
                </div>

                <div
                  className="chart-container position-relative"
                  style={{ height: "300px" }}
                >
                  {isChartLoading && (
                    <div className="position-absolute top-50 start-50 translate-middle">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                  {!isChartLoading && chartData.labels.length > 0 && (
                    <Bar data={chartData} options={chartOptions} />
                  )}
                  {!isChartLoading && chartData.labels.length === 0 && (
                    <div className="d-flex align-items-center justify-content-center h-100">
                      <p className="text-muted">No chart data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-lg-5">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-3">
                <div className="row">
                  <div className="col-lg-4">
                    <button>Current Rates</button>
                  </div>
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4">
                    <button >Sales Report</button>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-2">
                        <div className="text-center mb-2">
                          <button
                            className="btn btn-sm fs-6 text-white w-100"
                            style={{
                              background:
                                "linear-gradient(45deg, #FFD700, #FFA500)",
                              border: "none",
                              color: "white",
                            }}
                          >
                            Gold Rate
                          </button>
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold 1g - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "gold_1g_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold Coin - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "cold_coin_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold Pure Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "gold_pure_percentage",
                              ""
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-2">
                        <div className="text-center mb-2">
                          <button
                            className="btn btn-sm fs-6 text-white w-100"
                            style={{
                              background:
                                "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
                              border: "none",
                              color: "white",
                            }}
                          >
                            Silver Rate
                          </button>
                        </div>
                        <div className="mb-2">
                          <label className="form-label small">
                            Silver 1g - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_10g_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Silver Coin - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_coin_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Silver Pure Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_pure_percentage",
                              ""
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}



          <div className="col-lg-5">
            {/* <div className="card border-0 shadow-sm">
              <div className="card-body p-3">
                <div className="row">
                  <div className="col-lg-4">
                    <button>Current Rates</button>
                  </div>
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4">
                    <button >Sales Report</button>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-2">
                        <div className="text-center mb-2">
                          <button
                            className="btn btn-sm fs-6 text-white w-100"
                            style={{
                              background:
                                "linear-gradient(45deg, #FFD700, #FFA500)",
                              border: "none",
                              color: "white",
                            }}
                          >
                            Gold Rate
                          </button>
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold 1g - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "gold_1g_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold Coin - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "cold_coin_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Gold Pure Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "gold_pure_percentage",
                              ""
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card border-0 bg-light">
                      <div className="card-body p-2">
                        <div className="text-center mb-2">
                          <button
                            className="btn btn-sm fs-6 text-white w-100"
                            style={{
                              background:
                                "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
                              border: "none",
                              color: "white",
                            }}
                          >
                            Silver Rate
                          </button>
                        </div>
                        <div className="mb-2">
                          <label className="form-label small">
                            Silver 1g - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_10g_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Silver Coin - Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_coin_rate",
                              ""
                            )}
                            disabled
                          />
                        </div>

                        <div className="mb-2">
                          <label className="form-label small">
                            Silver Pure Rate
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={isLoading ? "Loading..." : ""}
                            value={getNestedValue(
                              responseDailyRates[0],
                              "silver_pure_percentage",
                              ""
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}


            <div className="container">
              <div className="row card">
                <div className="row">
                  <div className="col-lg-5 mt-2">
                    <button
                      className="btn btn-sm btn-primary w-100"
                      onClick={() => setShowReport(false)}
                    >
                      Current Rates
                    </button>
                  </div>
                  <div className="col-lg-3"></div>
                  <div className="col-lg-4 mt-2">
                    <button
                      className="btn btn-sm btn-success w-100"
                      onClick={() => setShowReport(true)}
                    >
                      Sales Report
                    </button>
                  </div>
                </div>
                {/* Show Sales Report */}
                {showReport ? (
                  <div className="col-lg-12 h-100">
                    <div className="card border-0 shadow-sm" style={{ minHeight: '337px' }}>
                      <div className="card-body p-3">
                        <h6 className="card-title mb-4">Sales Report</h6>
                        {/* {isLoading ? (
                          <p>Loading...</p>
                        ) : error ? (
                          <p className="text-danger">{error}</p>
                        ) : ( */}
                          <div style={{ maxHeight: '250px', overflowY: 'auto', overflowX: 'auto' }}>
                            <table className="table table-bordered table-striped table-hover table-sm align-middle rounded-3 overflow-hidden">
                              <thead className="text-uppercase text-center">
                                <tr>
                                  <th scope="col" className="fw-semibold">Manager</th>
                                  <th scope="col" className="fw-semibold">Staff</th>
                                  <th scope="col" className="fw-semibold">Total Sales</th>
                                </tr>
                              </thead>
                              <tbody className="text-center">
                                {Object.entries(groupedData).map(([managerId, { managerName, staffList }], index) =>
                                  staffList.map((staff, staffIndex) => (
                                    <tr key={`${managerId}-${staffIndex}`}>
                                      {staffIndex === 0 && (
                                        <td
                                          rowSpan={staffList.length}
                                          className="fw-bold text-primary text-start bg-light"
                                        >
                                          {managerName}
                                        </td>
                                      )}
                                      <td className="fw-medium text-start">{staff.staff}</td>
                                      <td
                                        className="fw-bold text-end fw-semibold text-success"
                                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                                      >
                                        {staff.total_sales.toLocaleString()}
                                      </td>
                                    </tr>
                                  ))
                                )}
                                {Object.keys(groupedData).length === 0 && (
                                  <tr>
                                    <td colSpan="3" className="text-muted py-3 text-center">
                                      No data available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                ) : (
                  // Show Current Rates
                  <div className="col-lg-12">
                    <div className="card border-0 shadow-sm" style={{ minHeight: '337px' }}>
                      <div className="card-body p-3">
                        <div className="row">
                          {/* Gold Section */}
                          <div className="col-lg-6">
                            <div className="card border-0 bg-light h-100">
                              <div className="card-body p-2">
                                <div className="text-center mb-2">
                                  <button
                                    className="btn btn-sm fs-6 text-white w-100"
                                    style={{
                                      background: "linear-gradient(45deg, #FFD700, #FFA500)",
                                      border: "none",
                                      color: "white",
                                    }}
                                  >
                                    Gold Rate
                                  </button>
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Gold 1g - Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "gold_1g_rate",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Gold Coin - Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "cold_coin_rate",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Gold Pure Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "gold_pure_percentage",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Silver Section */}
                          <div className="col-lg-6">
                            <div className="card border-0 bg-light h-100">
                              <div className="card-body p-2">
                                <div className="text-center mb-2">
                                  <button
                                    className="btn btn-sm fs-6 text-white w-100"
                                    style={{
                                      background: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
                                      border: "none",
                                      color: "white",
                                    }}
                                  >
                                    Silver Rate
                                  </button>
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Silver 1g - Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "silver_10g_rate",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Silver Coin - Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "silver_coin_rate",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                                <div className="mb-2">
                                  <label className="form-label small">Silver Pure Rate</label>
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder={isLoading ? "Loading..." : ""}
                                    value={getNestedValue(
                                      responseDailyRates[0],
                                      "silver_pure_percentage",
                                      ""
                                    )}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Chit and Loan Status */}
      {!isLoading && (
        <div className="row mt-3">
          <div className="col-lg-6">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <h6 className="card-title mb-3">Chit Status</h6>
                <div className="row text-center">
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Total Chits</h6>
                      <h5 className="text-primary mb-0">
                        {chitlistdashboard.total_chits || "0"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Today Open</h6>
                      <h5 className="text-success mb-0">
                        {chitlistdashboard.today_open || "0"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Today Closed</h6>
                      <h5 className="text-warning mb-0">
                        {chitlistdashboard.today_closed || "0"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <h6 className="card-title mb-3">Loan Status</h6>
                <div className="row text-center">
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Total Loans</h6>
                      <h5 className="text-primary mb-0">
                        {responseLoanStatus.total_loans || "0"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Today Open</h6>
                      <h5 className="text-success mb-0">
                        {responseLoanStatus.today_loans || "0"}
                      </h5>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 small">Today Closed</h6>
                      <h5 className="text-warning mb-0">
                        {responseLoanStatus.closed_loans || "0"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
